import ApiCalls from "GlobalUtils/ApiCalls";
import { AUTO_COMPLETE_SUGGESTION_TYPES } from "../constants";

const defaultSuggestionTypes = Object.entries(AUTO_COMPLETE_SUGGESTION_TYPES)
  .filter(
    ([key, value]) => value !== AUTO_COMPLETE_SUGGESTION_TYPES.discontinuedModel
  )
  .map(([key, value]) => value);

/**
 * @param {string} query
 * @param {array} suggestionTypes
 * @param {int} resultSize
 */
const fetchAutoCompletResults = ({
  query = "",
  suggestionTypes = defaultSuggestionTypes,
  resultSize = 5,
  showFeatured = false,
  isNcf = false,
}) => {
  const source = suggestionTypes.join(",");
  const options = {
    source: source,
    value: query,
    size: resultSize,
    showFeatured: showFeatured,
    isNcf: isNcf,
  };
  return ApiCalls.fetchApi({
    url: `/api/v3/autocomplete/`,
    options: options,
    requestInit: {
      method: "GET",
      credentials: "same-origin",
    },
  });
};

export const globalSearchApis = {
  fetchAutoCompletResults,
};
